(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function(){
    function syncFooter(footer){
      if(!footer || footer.dataset.nnFooterReady === 'true') return;
      footer.dataset.nnFooterReady = 'true';
      var media = window.matchMedia('(max-width: 767px)');
      var groups = Array.prototype.slice.call(footer.querySelectorAll('.nn-footer__group'));
      function sync(){
        if(media.matches){
          groups.forEach(function(group){ group.open = false; });
        }else{
          groups.forEach(function(group){ group.open = true; });
        }
      }
      groups.forEach(function(group){
        group.addEventListener('toggle',function(){
          if(!media.matches && !group.open) group.open = true;
          if(media.matches && group.open){
            groups.forEach(function(other){ if(other !== group) other.open = false; });
          }
        });
      });
      if(media.addEventListener) media.addEventListener('change',sync);
      else media.addListener(sync);
      sync();
    }
    function init(scope){
      var root = scope || document;
      if(root.matches && root.matches('[data-nn-footer]')) syncFooter(root);
      root.querySelectorAll('[data-nn-footer]').forEach(syncFooter);
    }
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function(){ init(document); });
    else init(document);
    document.addEventListener('shopify:section:load',function(event){ init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
